<div class="account-wrapper">
  <app-bordered-group class="col-5 account-content" header="">
    <ng-container *ngIf="!edit">
      <app-account-info
        [accountDetails]="accountDetails"
        [accountCategories]="accountCategories"
        [lastUserLoginTime]="lastUserLoginTime"
      ></app-account-info>
    </ng-container>
    <ng-container *ngIf="edit">
      <app-edit-account-details-form
        [progress]="updateAccountInProgress"
        [accountDetails]="accountDetails"
        (formSubmit)="updateAccount.emit($event)"
        (cancelSubmit)="edit = false"
        [accountCategories]="accountCategories"
      ></app-edit-account-details-form>
    </ng-container>
    <div class="account-info-edit">
      <button
        *ngIf="!edit"
        class="btn btn-link"
        (click)="editDetails($event)"
        [disabled]="
          !hasOrderManagerRole ||
          accountState === AccountState.Failed ||
          !accountCategories?.length
        "
      >
        <i class="fas fa-pencil-alt"></i>Edit
      </button>
    </div>
    <app-pro-account-ids
      [accountState]="accountState"
      [proAccounts]="proAccounts"
      [proAccountsIsLoading]="proAccountsIsLoading"
      [mappedProIds]="mappedProIds"
      [loadingProAccountIds]="loadingProAccountIds"
      [canPlaceOrders]="canPlaceOrders"
      (proAccountNewLink)="proAccountNewLink.emit($event)"
      (proAccountDeleteLink)="proAccountDeleteLink.emit($event)"
    ></app-pro-account-ids>
    <app-mapped-pro-table
      *ngIf="proAccounts && proAccounts.length"
      [migrations]="proSyncMigrations"
      [isLoadingMigrations]="isLoadingMigrations"
      (navigateToMigration)="navigateToMigration.emit($event)"
    >
    </app-mapped-pro-table>

    <div>
      <h5 class="header">License package</h5>
      <ng-container *ngIf="!licensePackagesError; else packageError">
        <app-loading-spinner *ngIf="isLoadingLicensePackages; else packages">
          Loading packages...
        </app-loading-spinner>
        <ng-template #packages>
          <div *ngIf="licensePackage" class="row">
            <div class="col-auto">
              <app-account-package
                [attr.bootstrap-status]="licenseBootstrapState"
                [package]="licensePackage?.displayName"
                [licenses]="licensePackage?.licenses"
                [innerId]="'currentPackage-' + licensePackage?.code"
                [selected]="
                  accountDetails.licensePackage === licensePackage?.code
                "
              >
              </app-account-package>
            </div>
          </div>
          <div class="row">
            <div class="col-auto">
              <i
                >Change of package and licenses, see licenses tab
                <span class="link" (click)="showLicenses.emit()">here</span></i
              >
            </div>
          </div>
        </ng-template>
      </ng-container>
      <ng-template #packageError>
        <span class="text-danger"> Could not fetch packages </span>
      </ng-template>
    </div>
    <div>
      <app-account-unique-identifiers
        [canCreateCrmKeyspace]="canCreateCrmKeyspace"
        [hasWawBackOffice]="hasWawBackOffice"
        [isCrmKeyspaceCreating]="isCrmKeyspaceCreating"
        [isCrmKeyspaceTimeoutFailed]="isCrmKeyspaceTimeoutFailed"
        [rebootstrapLicensesIsLoading]="rebootstrapLicensesIsLoading"
        [rebootstrapLicensesTimeoutFailed]="rebootstrapLicensesTimeoutFailed"
        (addCrm)="createCrmKeyspace.emit()"
        (rebootstrapLicenses)="rebootstrapLicenses.emit()"
      ></app-account-unique-identifiers>
    </div>
  </app-bordered-group>
  <app-bordered-group class="col-6 account-content" header="">
    <app-account-trial-upgrade
      *ngIf="isTrial"
      [accountDetails]="accountDetails"
      [licensePackages]="licensePackages"
      [sharePointUrl]="sharePointUrl"
      [hasOrderManagerRole]="hasOrderManagerRole"
      [progress]="upgradeAccountInProgress"
      (upgradeTrial)="upgradeTrial.emit($event)"
    ></app-account-trial-upgrade>
    <app-loading-spinner *ngIf="isLoadingAccountSettings; else settings">
      Loading account settings ...
    </app-loading-spinner>
    <ng-template #settings>
      <app-number-order-field
        [title]="'User seats'"
        [leftFieldlabel]="'Allowed seats *'"
        [leftFieldPlaceholder]="'Allowed seats'"
        [valueToUpdate]="'userSeats'"
        [buttonTooltip]="'You have to be an order manager to update user seats'"
        [userPermissions]="userPermissions"
        (editInput)="editAccountSettings.emit($event)"
        [isUpdatingInput]="isUpdatingUserSeats"
        [inputValue]="accountSettings?.userSeats"
        [validationErrorMessages]="{
          minValue: usersErrorTextMin,
          maxValue: 'Up to 1000 users can be allowed for an account'
        }"
        [maxValue]="1000"
      ></app-number-order-field>
      <app-number-order-field
        [title]="'Audience Profiles'"
        [leftFieldlabel]="'Number of profiles (0 below means unlimited) *'"
        [leftFieldPlaceholder]="'Number of profiles'"
        [valueToUpdate]="'audiencePackageSize'"
        [buttonTooltip]="
          'You have to be an order manager to update audience profiles'
        "
        [userPermissions]="userPermissions"
        (editInput)="editAccountSettings.emit($event)"
        [isUpdatingInput]="isUpdatingAudiencePackageSize"
        [inputValue]="accountSettings?.audiencePackageSize"
        [maxValue]="9999999"
        [validationErrorMessages]="{ minValue: audienceErrorTextMin }"
      ></app-number-order-field>
      <app-number-order-field
        [title]="false"
        [leftFieldlabel]="'Number of sections *'"
        [leftFieldPlaceholder]="'Number of sections'"
        [valueToUpdate]="'sectionsLimit'"
        [buttonTooltip]="
          'You have to be an order manager to update number of sections'
        "
        [userPermissions]="userPermissions"
        (editInput)="editAccountSettings.emit($event)"
        [isUpdatingInput]="isUpdatingSectionsLimit"
        [inputValue]="accountSettings?.sectionsLimit"
        [maxValue]="250"
        [validationErrorMessages]="{ minValue: sectionsErrorTextMin }"
      ></app-number-order-field>
    </ng-template>

    <ng-container *ngIf="hasSmsCreditSubscription; else smsCreditsV1">
      <app-sms-credit-subscription></app-sms-credit-subscription>
    </ng-container>
    <ng-template #smsCreditsV1>
      <app-loading-spinner *ngIf="isLoadingSmsCredits; else smsCredits">
        Loading sms credits ...
      </app-loading-spinner>

      <ng-template #smsCredits>
        <app-sms-credits
          [userPermissions]="userPermissions"
          [isUpdatingSmsCredits]="isUpdatingSmsCredits"
          (updateSmsCredits)="updateSmsCredits.emit($event)"
          [currentSmsCredits]="currentSmsCredits"
        ></app-sms-credits>
      </ng-template>
    </ng-template>

    <app-email-quota
      [quota]="emailQuota"
      [loadingMonthlyQuota]="emailMonthlyQuotaIsLoading"
      [loadingOneTimeQuota]="emailOneTimeQuotaIsLoading"
      [disabled]="!canPlaceOrders"
      (addQuota)="addQuota.emit($event)"
    ></app-email-quota>

    <app-email-delivery-settings
      [disabled]="isTrial || !canPlaceOrders"
      [dkimDomains]="dkimDomains"
      [allLicenses]="allLicenses"
      (update)="updateDkimDomains.emit($event)"
    ></app-email-delivery-settings>
  </app-bordered-group>
</div>
